import { getNodeString, Value } from '@udecode/plate-common';

export const getDescriptionFromRichTextArea = (value: Value) => {
  return value?.map(n => getNodeString(n)).join(' ');
};

export const isRichTextAreaEmpty = (value: Value) => {
  const textString = getDescriptionFromRichTextArea(value);

  return textString.trim().length === 0;
};

export const extractSlateText = (nodes: any): string => {
  if (!Array.isArray(nodes)) return '';
  return nodes.map((n: any) => {
    if (typeof n.text === 'string') return n.text;
    if (Array.isArray(n.children)) return extractSlateText(n.children);
    return '';
  }).join(' ').trim();
};
